import { useMemo } from 'react'
import { IntegrationConfig, IssueStatus, Resolution } from '../../api/shared'
import { isEmpty } from '../../../../../util'
import { TRACE_STATUSES, VULN_STATUS_ALL } from '../legacy-constants'

export interface UseDetermineJiraStatusesParameters {
  issueTypeStatuses?: IssueStatus[]
  resolutions?: Resolution[]
  integration: IntegrationConfig
}

/**
 * The initial integration row only has strings in it, not the full objects needed for the form fields.
 */
export const usePopulateIntegration = ({
  issueTypeStatuses,
  resolutions,
  integration
}) => {
  return useMemo<IntegrationConfig | void>(() => {
    // wait for necessary dependencies to initialize
    if (
      issueTypeStatuses &&
      resolutions &&
      !isEmpty(issueTypeStatuses) &&
      !isEmpty(resolutions) &&
      typeof integration.issue_status === 'string'
    ) {
      const fullIssueStatus = issueTypeStatuses.find(
        (status) => status.id === integration.issue_status
      )
      const fullIssueResolution = resolutions.find(
        (resolution) => resolution.id === integration.issue_resolution
      )
      const fullTraceStatus = VULN_STATUS_ALL.find(
        (traceStatus) => traceStatus.value === integration.trace_status
      )
      const fullTraceSubstatus = TRACE_STATUSES.find(
        (traceStatus) => traceStatus.value === integration.trace_substatus
      )
      return {
        issue_status: fullIssueStatus ?? integration.issue_status,
        issue_resolution: fullIssueResolution,
        trace_status: fullTraceStatus ?? integration.trace_status,
        trace_substatus: fullTraceSubstatus
      }
    }
    return integration
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [
    issueTypeStatuses,
    resolutions,
    integration.trace_status,
    integration.issue_status
  ])
}
